import * as React from 'react';
import PropTypes from 'prop-types';
import { getImage } from 'gatsby-plugin-image';

import Layout from 'components/Layout';
import SEO from 'components/SEO';
import { PostShape } from 'utils/props';

import PostHero from 'pageComponents/Post/PostHero';
import PostBody from 'pageComponents/Post/PostBody';
import UpcomingEpisodeHero from 'pageComponents/Post/UpcomingEpisodeHero';
import UpcomingEpisodeBody from 'pageComponents/Post/UpcomingEpisodeBody';
import RelatedContent from 'pageComponents/Post/RelatedContent';

function getPostType(post) {
  if (post.sleuthTvLive) {
    return 'upcomingEpisode';
  } else if (post.videoPost) {
    return 'video';
  } else {
    return 'text';
  }
}

function PostTemplate({ pageContext }) {
  const { post } = pageContext;
  const postType = getPostType(post);

  if (postType === 'upcomingEpisode') {
    return (
      <Layout>
        <UpcomingEpisodeHero post={post} />
        <UpcomingEpisodeBody post={post} />
      </Layout>
    );
  }

  return (
    <Layout>
      <PostHero post={post} postType={postType} />
      <PostBody post={post} />
      {post.related.length > 0 && <RelatedContent post={post} />}
    </Layout>
  );
}

PostTemplate.propTypes = {
  pageContext: PropTypes.shape({
    post: PostShape,
  }),
};

export function Head({ location, pageContext }) {
  const { post } = pageContext;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    headline: post.title,
    image: getImage(post.featureImage.image.asset).images.fallback?.src,
    datePublished: post._publishedAt,
    dateModified: post._updatedAt,
    author: [
      {
        '@type': 'Person',
        name: post.author?.name || 'Sleuth',
        ...(post.author?.image && {
          url: getImage(post.author.image.asset).images.fallback?.src,
        }),
      },
    ],
  };

  return (
    <SEO
      title={post.title}
      description={post.description}
      imageUrl={post.featureImage.image.asset.url}
      location={location}
      schema={schema}
    />
  );
}

export default PostTemplate;
